import React from 'react';

const UsuariosAccesoSelector = ({ usuarios = [], selectedIds = [], onChange, hintText }) => {
  const idsSet = new Set(selectedIds.map(String));

  const toggleUsuario = (uid) => {
    const s = String(uid);
    const next = new Set(idsSet);
    if (next.has(s)) next.delete(s);
    else next.add(s);
    onChange([...next]);
  };

  const seleccionarTodos = () => {
    onChange(usuarios.map((u) => String(u.id)));
  };

  const deseleccionarTodos = () => {
    onChange([]);
  };

  return (
    <div className="form-group multiselect-group">
      <div className="multiselect-header">
        <span className="form-label-inline">Usuarios con acceso</span>
        {usuarios.length > 0 && (
          <div className="multiselect-actions">
            <button type="button" className="btn-link-multiselect" onClick={seleccionarTodos}>
              Seleccionar todos
            </button>
            <span className="multiselect-actions-sep" aria-hidden="true">·</span>
            <button type="button" className="btn-link-multiselect" onClick={deseleccionarTodos}>
              Deseleccionar todos
            </button>
          </div>
        )}
      </div>
      <div className="multiselect-options">
        {usuarios.length === 0 ? (
          <span className="multiselect-empty">No hay usuarios activos</span>
        ) : (
          usuarios.map((u) => (
            <label key={u.id} className="checkbox-inline">
              <input
                type="checkbox"
                checked={idsSet.has(String(u.id))}
                onChange={() => toggleUsuario(u.id)}
              />
              <span>{u.nombre || u.username}</span>
            </label>
          ))
        )}
      </div>
      {hintText && <small className="multiselect-hint">{hintText}</small>}
    </div>
  );
};

export default UsuariosAccesoSelector;
